// extracted by mini-css-extract-plugin
export var linkIcon = "footer-module--linkIcon--2xoUJ";
export var linkIconContainer = "footer-module--linkIconContainer--fcMer";
export var copyrightText = "footer-module--copyrightText--3b8GI";